"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgCarSideSolid24 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M0 0h24v24H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "m16.98 9.914.247.043c.77.143 3.072.693 3.072 2.367v2.453h-1.483a2.124 2.124 0 0 1-4.248 0H9.17a2.124 2.124 0 1 1-4.242-.156c-.819-.594-1.227-1.265-1.227-2.013 0-1.222.204-2.478.51-3.53l-.423-1.45 1.338-.206c.344-.05.697-.099.983-.131l1.176-.11c2.298-.186 7.129-.328 9.695 2.733Zm-9.934 3.739a1.124 1.124 0 1 0 0 2.248 1.124 1.124 0 0 0 0-2.248Zm9.646 0a1.124 1.124 0 1 0 0 2.248 1.124 1.124 0 0 0 0-2.248Z", fill: "currentColor" })] })) }))); };
exports.default = SvgCarSideSolid24;
